import type { State } from '../types';
import type { TabKey } from './types';
import typeof { APP_LIFECYCLE_STATE } from './constants';

export function getAppError(state: State): Error {
  return state.app.error;
}

export function getActiveTab(state: State): TabKey {
  return state.app.activeTab;
}

export function isInitialDataLoaded(state: State): boolean {
  return state.app.isInitialDataLoaded;
}

export function getAppLifecycleState(state: State): $Keys<APP_LIFECYCLE_STATE> {
  return state.app.appLifecycleState;
}



// WEBPACK FOOTER //
// ./src/redux/app/selectors.js